/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Checkboxes_Onsale1Inputs */

const id_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedang Diskon`)
};

const ms_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedang Jualan`)
};

const da_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`På Tilbud`)
};

const de_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im Angebot`)
};

const en_us2_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On Sale`)
};

const es_es2_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con descuento`)
};

const es_mx2_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con descuento`)
};

const fil_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naka-sale`)
};

const fr_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En promotion`)
};

const it_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In sconto`)
};

const hu_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akciós`)
};

const nl_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In de aanbieding`)
};

const no_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`På salg`)
};

const pl_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`W promocji`)
};

const pt_br2_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com desconto`)
};

const pt_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em promoção`)
};

const ro_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La reducere`)
};

const fi_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alemuksessa`)
};

const sv_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`På rea`)
};

const vi_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang giảm giá`)
};

const tr_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İndirimde`)
};

const cs_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ve slevě`)
};

const bg_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`На промоция`)
};

const ru_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Со скидкой`)
};

const uk_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зі знижкою`)
};

const ar_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مخفض`)
};

const hi_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बिक्री पर`)
};

const th_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลดราคา`)
};

const ja_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セール中`)
};

const zh_cn2_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`促销中`)
};

const zh_hant1_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`促銷中`)
};

const ko_search_checkboxes_onsale1 = /** @type {(inputs: Search_Checkboxes_Onsale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`할인 중`)
};

/**
* | output |
* | --- |
* | "On Sale" |
*
* @param {Search_Checkboxes_Onsale1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_checkboxes_onsale1 = /** @type {((inputs?: Search_Checkboxes_Onsale1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Checkboxes_Onsale1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_checkboxes_onsale1(inputs)
	if (locale === "ms") return ms_search_checkboxes_onsale1(inputs)
	if (locale === "da") return da_search_checkboxes_onsale1(inputs)
	if (locale === "de") return de_search_checkboxes_onsale1(inputs)
	if (locale === "en-US") return en_us2_search_checkboxes_onsale1(inputs)
	if (locale === "es-ES") return es_es2_search_checkboxes_onsale1(inputs)
	if (locale === "es-MX") return es_mx2_search_checkboxes_onsale1(inputs)
	if (locale === "fil") return fil_search_checkboxes_onsale1(inputs)
	if (locale === "fr") return fr_search_checkboxes_onsale1(inputs)
	if (locale === "it") return it_search_checkboxes_onsale1(inputs)
	if (locale === "hu") return hu_search_checkboxes_onsale1(inputs)
	if (locale === "nl") return nl_search_checkboxes_onsale1(inputs)
	if (locale === "no") return no_search_checkboxes_onsale1(inputs)
	if (locale === "pl") return pl_search_checkboxes_onsale1(inputs)
	if (locale === "pt-BR") return pt_br2_search_checkboxes_onsale1(inputs)
	if (locale === "pt") return pt_search_checkboxes_onsale1(inputs)
	if (locale === "ro") return ro_search_checkboxes_onsale1(inputs)
	if (locale === "fi") return fi_search_checkboxes_onsale1(inputs)
	if (locale === "sv") return sv_search_checkboxes_onsale1(inputs)
	if (locale === "vi") return vi_search_checkboxes_onsale1(inputs)
	if (locale === "tr") return tr_search_checkboxes_onsale1(inputs)
	if (locale === "cs") return cs_search_checkboxes_onsale1(inputs)
	if (locale === "bg") return bg_search_checkboxes_onsale1(inputs)
	if (locale === "ru") return ru_search_checkboxes_onsale1(inputs)
	if (locale === "uk") return uk_search_checkboxes_onsale1(inputs)
	if (locale === "ar") return ar_search_checkboxes_onsale1(inputs)
	if (locale === "hi") return hi_search_checkboxes_onsale1(inputs)
	if (locale === "th") return th_search_checkboxes_onsale1(inputs)
	if (locale === "ja") return ja_search_checkboxes_onsale1(inputs)
	if (locale === "zh-CN") return zh_cn2_search_checkboxes_onsale1(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_checkboxes_onsale1(inputs)
	return ko_search_checkboxes_onsale1(inputs)
});
export { search_checkboxes_onsale1 as "search.checkboxes.onSale" }